export default {
  title1: 'Candidatura',
  title2: ['efetuada', 'com sucesso'],
  msg: ['Obrigado pela candidatura', 'Boa sorte!'],

  buttonContent: 'VOLTAR',
}
